import { Service } from 'typedi';
import { Container } from '../../../symphony';

import { SlNavigationDataService } from './sl-navigation-data.service';
import { SlNavigationContext } from '../global-constants';
import { SlNavbarState } from '../global-interface';
import { ISlFooterService } from '../../../shared/public/globalInterfaces/globalInterfaces';
import { DynamicPaywallLoader } from '../../../_paywalls/public/DynamicPaywallLoader';
import { Touchpoint } from '../../../api/public/subscription-api';

@Service()
export class SlFooterService implements ISlFooterService {
  private paywallLoader = DynamicPaywallLoader.ensureRegistered();

  private dataService = Container.take(
    SlNavigationContext,
    SlNavigationDataService,
  );

  public show() {
    this.dataService.footerState$.next(SlNavbarState.shown);
  }

  public hide() {
    this.dataService.footerState$.next(SlNavbarState.hidden);
  }

  public openPaywall = () => {
    this.paywallLoader.openPaywall({
      touchpoint: Touchpoint.footer,
      props: {}
    });
  };
}
